import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{add-html-classes \'marketing\'}}\n\n<NotFound @error={{this.error}} />\n",{ moduleName: "sh-www/templates/404.hbs" })